import axios from 'axios'
import {serialize} from '../../../core/_util'
const API_URL = process.env.REACT_APP_BASE_API_URL

const GET_FOUNDER_MARKRT_DEALS = `${API_URL}/deals/list`
const SEND_FOUNDER_MARKET_DEALS = `${API_URL}/deals/claim`
const GET_RESOURCES = `${API_URL}/resources`
const GET_DOWNLOADED_RESOURCES = `${API_URL}/resource-downloads`
const RESOURCES_DOWNLOADS = `${API_URL}/resource-downloads`

export const getResourcesData = (
  companyId: number,
  page: number,
  size: number,
  search?: string | undefined,
  categories?: string | undefined,
  sort_by?:string|undefined,
  sort_order?:string|undefined
) => {
  const object = {
    page,
    size,
    search,
    categories,
    sort_by,
    sort_order,
  }
  return axios.get(`${GET_RESOURCES}?${serialize(object)}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getDownloadedResourcesData = (companyId: number) => {
  return axios.get(GET_DOWNLOADED_RESOURCES, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getResourcesDetailData = (id: string, companyId: number) => {
  return axios.get(`${GET_RESOURCES}/${id}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getResourcesDeals = (page: number, size: number, companyId: number) => {
  const object = {
    page: page,
    size: size,
  }
  return axios.get(`${GET_FOUNDER_MARKRT_DEALS}/${companyId}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const sendResourcesDealEmail = (dealId: number, payload: {companyId: number}) => {
  return axios.post(`${SEND_FOUNDER_MARKET_DEALS}/${dealId}`, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const downloadResourceApi = (payload: any, companyId: number) => {
  return axios.post(`${RESOURCES_DOWNLOADS}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}
